const actions = {
  GET_UPLOAD_STATUS_BEGIN: 'GET_UPLOAD_STATUS_BEGIN',
  GET_UPLOAD_STATUS_SUCCESS: 'GET_UPLOAD_STATUS_SUCCESS',
  GET_UPLOAD_STATUS_ERR: 'GET_UPLOAD_STATUS_ERR',

  SET_UPLOAD_STATUS_BEGIN: 'SET_UPLOAD_STATUS_BEGIN',
  SET_UPLOAD_STATUS_SUCCESS: 'SET_UPLOAD_STATUS_SUCCESS',
  SET_UPLOAD_STATUS_ERR: 'SET_UPLOAD_STATUS_ERR',

  GET_UPLOADED_DOC_PROMPT_BEGIN: 'GET_UPLOADED_DOC_PROMPT_BEGIN',
  GET_UPLOADED_DOC_PROMPT_SUCCESS: 'GET_UPLOADED_DOC_PROMPT_SUCCESS',
  GET_UPLOADED_DOC_PROMPT_ERR: 'GET_UPLOADED_DOC_PROMPT_ERR',

  SET_UPLOADED_DOC_PROMPT_BEGIN: 'SET_UPLOADED_DOC_PROMPT_BEGIN',
  SET_UPLOADED_DOC_PROMPT_SUCCESS: 'SET_UPLOADED_DOC_PROMPT_SUCCESS',
  SET_UPLOADED_DOC_PROMPT_ERR: 'SET_UPLOADED_DOC_PROMPT_ERR',

  getUploadStatusBegin: () => {
    return {
      type: actions.GET_UPLOAD_STATUS_BEGIN,
    };
  },

  getUploadStatusSuccess: data => {
    return {
      type: actions.GET_UPLOAD_STATUS_SUCCESS,
      data,
    };
  },

  getUploadStatusErr: err => {
    return {
      type: actions.GET_UPLOAD_STATUS_ERR,
      err,
    };
  },

  setUploadStatusBegin: () => {
    return {
      type: actions.SET_UPLOAD_STATUS_BEGIN,
    };
  },

  setUploadStatusSuccess: data => {
    return {
      type: actions.SET_UPLOAD_STATUS_SUCCESS,
      data,
    };
  },

  setUploadStatusErr: err => {
    return {
      type: actions.SET_UPLOAD_STATUS_ERR,
      err,
    };
  },

  getUploadDocPromptBegin: () => {
    return {
      type: actions.GET_UPLOADED_DOC_PROMPT_BEGIN,
    };
  },

  getUploadDocPromptSuccess: data => {
    return {
      type: actions.GET_UPLOADED_DOC_PROMPT_SUCCESS,
      data,
    };
  },

  getUploadDocPromptErr: err => {
    return {
      type: actions.GET_UPLOADED_DOC_PROMPT_ERR,
      err,
    };
  },

  setUploadDocPromptBegin: () => {
    return {
      type: actions.SET_UPLOADED_DOC_PROMPT_BEGIN,
    };
  },

  setUploadDocPromptSuccess: data => {
    return {
      type: actions.SET_UPLOADED_DOC_PROMPT_SUCCESS,
      data,
    };
  },

  setUploadDocPromptErr: err => {
    return {
      type: actions.SET_UPLOADED_DOC_PROMPT_ERR,
      err,
    };
  },
};

export default actions;
